import React from "react";
import PrivateCustomerRoutes from '../../components/routes/CustomerRoutes';
import { Box } from '@chakra-ui/react'
import Topbar from '../TopBar';
import { CustomerType } from "../../types/page";

type Props = {
    customer: CustomerType
}

export default function OuterDashboard({ customer }: Props) {    
    return (
        <div>
            {customer
                && (
                    <Box style={{ height: '100vh' }}>
                        <Topbar />
                        <PrivateCustomerRoutes />
                    </Box>
                )}
        </div>
    )
}